<script>
    import { afterUpdate } from "svelte";
    export let current_page = 1;
    export let page_count = 1;
    export let switch_page_func;
    let pagedatas = [];
    afterUpdate(() => {
        loadPage(current_page, page_count);
    });
    function loadPage(curPage, totalPage) {
        // max page link is 5
        let pages = [];
        let min_num = curPage - 2;
        if (min_num < 1) min_num = 1;
        let max_num = min_num + 4;
        if (max_num > totalPage) {
            max_num = totalPage;
            // keep 5
            min_num = max_num - 4;
            if (min_num < 1) min_num = 1;
        }
        for (let i = min_num; i <= max_num; i++) {
            let iscurrent = i == curPage;
            pages.push({ pagenumber: i, iscurrent: iscurrent });
        }
        pagedatas = pages;
    }
</script>

<div class="row">
    <div class="col-md-8">
        <div class="text-left">
            <ul class="pagination">
                <li class="page-item">
                    <a
                        href={"javascript:;"}
                        class="page-link"
                        on:click={() => switch_page_func(1)}
                    >
                        <i class="bi bi-chevron-bar-left" />
                    </a>
                </li>
                {#if current_page > 1}
                    <li class="page-item">
                        <a
                            href={"javascript:;"}
                            class="page-link"
                            on:click={() => switch_page_func(current_page - 1)}
                        >
                            <i class="bi bi-chevron-double-left" />
                        </a>
                    </li>
                {/if}
                {#each pagedatas as pagedata}
                    <li class="page-item" class:active={pagedata.iscurrent}>
                        <a
                            href={"javascript:;"}
                            class="page-link"
                            on:click={() =>
                                switch_page_func(pagedata.pagenumber)}
                        >
                            {pagedata.pagenumber}
                        </a>
                    </li>
                {/each}
                {#if current_page < page_count}
                    <li class="page-item">
                        <a
                            href={"javascript:;"}
                            class="page-link"
                            on:click={() => switch_page_func(current_page + 1)}
                        >
                            <i class="bi bi-chevron-double-right" />
                        </a>
                    </li>
                {/if}
                <li class="page-item">
                    <a
                        href={"javascript:;"}
                        class="page-link"
                        on:click={() => switch_page_func(page_count)}
                    >
                        <i class="bi bi-chevron-bar-right" />
                    </a>
                </li>
            </ul>
        </div>
    </div>
    <div class="col-md-4 text-right">
        第 {current_page} 页 / 共 {page_count} 页
    </div>
</div>

<style>
</style>
